import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlpataMail } from 'src/app/core/model/AlpataMail';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as L from 'leaflet';

@Component({
  selector: 'app-home-en',
  templateUrl: './home-en.component.html',
  styleUrls: ['./home-en.component.scss'],
})
export class HomeEnComponent implements OnInit {
  gosterilenIsleme: number = 0;
  item = new AlpataMail();
  ekleGuncelleIsLoading = false;
  fileToUpload: File = null;
  dosyaBase64Hali: any;
  dosyaAdi: string;

  @ViewChild('captchaRef2') captchaRef2: ElementRef;
  private _reCaptchaId: number;
  private SITE_ID = environment.RecaptchaSiteKey;
  private RESPONSE_KEY: string;

  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {
    let mapOptions = {
      center: [39.87, 31.6],
      zoom: 9,
    };

    let map = new L.map('openmap', mapOptions);

    let layer = new L.TileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    );
    map.addLayer(layer);

    let customIcon = {
      iconUrl: 'https://image.flaticon.com/icons/png/512/1397/1397898.png',
      iconSize: [40, 40],
    };

    let myIcon = L.icon(customIcon);

    let iconOptions = {
      title: 'Alpata',
      draggable: false,
    };

    var markerArr = [];

    var Lat = '39,7972333';
    var Long = '30,53315';
    var title =
      'NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.';
    var pop = 'True';
    var address = 'Zafer Mahallesi Esener Sokak No:3 Tepebaşı Eskişehir ';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39,7455528';
    var Long = '30,613383333333335';
    var title = 'NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ';
    var pop = 'True';
    var address =
      'Ankara Asfaltı 75.Yıl Mah. &#199;evreyolu Bulvarı No:2 Odunpazarı Eskişehir';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39,7460083';
    var Long = '30,613994444444447';
    var title = 'ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.';
    var pop = 'True';
    var address =
      'Ankara Asfaltı 75. Yıl Mah. &#199;evreyolu Bulvarı No:2 Odunpazarı Eskişehir';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39,7515417';
    var Long = '30,646708333333333';
    var title = 'ALP HAVACILIK SANAYİ VE TİCARET A.Ş.';
    var pop = 'True';
    var address = 'Organize Sanayi B&#246;lgesi 8. Cadde 26110 Eskişehir';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39,7524556';
    var Long = '30,635080555555554';
    var title = 'NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ';
    var pop = 'True';
    var address =
      'Organize Sanayi B&#246;lgesi Bilim Caddesi Yazılım Kule No:5/401  Odunpazarı Eskişehir';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39,908979';
    var Long = '32,755191';
    var title = 'ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.';
    var pop = 'True';
    var address =
      'Mustafa Kemal Mahallesi Dumlupınar Bulvarı Tepeprime İş Merkezi No:266 A Blok D:35 &#199;ankaya Ankara';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    var Lat = '39.76020';
    var Long = '30.69330';

    var title = 'ALPATA HAVACILIK SANAYİ VE TİCARET A.Ş.';
    var pop = 'True';
    var address =
      'Organize Sanayi Bölgesi 34. Cadde Numara 15 26110 Odunpazarı/Eskişehir';

    var marker = {
      latitude: parseFloat(Lat.replace(/\,/g, '.')),
      longitude: parseFloat(Long.replace(/\,/g, '.')),
      html:
        "<div style='width:210px;text-align:center;font-weight:bold'>" +
        title +
        "<p style='font-size:9pt;'>" +
        address +
        '</p></div>',
      popup: false,
    };
    markerArr.push(marker);

    for (let index = 0; index < markerArr.length; index++) {
      const element = markerArr[index];

      let omarker = new L.Marker(
        [element.latitude, element.longitude],
        iconOptions
      );
      omarker.addTo(map);
      omarker.bindPopup(element.html);
    }
  }

  ngAfterViewInit() {
    const grecaptcha = (window as any).grecaptcha;
    if (grecaptcha) {
      debugger;
      this._reCaptchaId = grecaptcha.render(this.captchaRef2.nativeElement, {
        sitekey: this.SITE_ID,
        callback: (resonse) => this.reCapchaSuccess(resonse),
        'expired-callback': () => this.reCapchaExpired(),
      });
    }
  }

  reCapchaSuccess(data: any) {
    if (data) {
      this.RESPONSE_KEY = data;
    }
  }

  reCapchaExpired() {
    alert('Oops! reCAPTCHA expired.');
  }

  tempId: number;
  GetCompanyCities(id: number) {
    this.tempId = JSON.parse(JSON.stringify(id));
    if (this.gosterilenIsleme != id) {
      this.gosterilenIsleme = id;
    } else {
      this.gosterilenIsleme = -1;
    }
  }

  gosterilenIsletmeGosterGizle() {
    this.gosterilenIsleme = null;
  }

  /**
   * item değerinde yer alan tanım için ekle-güncelle işlemlerinin gerçekleştirilmesi.
   *
   * @memberof HomeEnComponent
   */
  async ekleGuncelle(param: number) {
    try {
      this.item.MailTipi = param;
      this.item.ResponseKey = this.RESPONSE_KEY;
      this.item.SirketTipi = parseInt(this.item.SirketTipi);
      if (param == 0) {
        this.item.DosyaBase64 = this.dosyaBase64Hali;
        this.item.DosyaAdi = this.dosyaAdi;
      }
      this.ekleGuncelleIsLoading = true;

      return this.httpClient
        .post<any>('/api/v1/AlpataMail/AlpataMail/MailGonder', this.item)
        .toPromise();
    } catch (error) {
      console.log(error);
    } finally {
      this.itemTemizle();
      this.ekleGuncelleIsLoading = false;
    }
  }

  handleFileInput(files: FileList) {
    if (files.length > 0) {
      const file = files[0];
      this.dosyaAdi = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.dosyaBase64Hali = reader.result;
      };
    }
  }

  itemTemizle() {
    this.item = new AlpataMail();
  }
}
